/**
 * Static page backdrop — ambient gradients only (no canvas / moving particles).
 */

export const GlobalBackground = () => (
  <div
    className="fixed inset-0 pointer-events-none select-none"
    style={{ zIndex: 0 }}
    aria-hidden="true"
  >
    <div
      className="absolute inset-0"
      style={{
        background: [
          "radial-gradient(ellipse 90% 55% at 50% -5%, hsl(217 91% 60% / 0.06) 0%, transparent 65%)",
          "radial-gradient(ellipse 45% 45% at 8% 55%, hsl(270 80% 62% / 0.05) 0%, transparent 60%)",
          "radial-gradient(ellipse 45% 45% at 92% 55%, hsl(162 70% 45% / 0.04) 0%, transparent 60%)",
        ].join(", "),
      }}
    />
  </div>
);

export default GlobalBackground;
